module.exports = __webpack_public_path__ + "img/legacy_9.df7c229b.jpg";